// src/components/UserList.tsx

import React from "react";
import { User } from "@/lib/types";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from "@/components/ui/table"; // Import Shadcn's Table components

interface UserListProps {
  users: User[];
}

export function UserList({ users }: UserListProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Email</TableHead>
          <TableHead>Name</TableHead>
          <TableHead>Active</TableHead>
          <TableHead>Superuser</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {users.length === 0 ? (
          <TableRow>
            <TableCell colSpan={4} className="text-center">
              No users found.
            </TableCell>
          </TableRow>
        ) : (
          users.map((user) => (
            <TableRow key={user.id}>
              <TableCell>{user.email}</TableCell>
              <TableCell>{user.name || "-"}</TableCell>
              <TableCell>{user.is_active ? "Yes" : "No"}</TableCell>
              <TableCell>{user.is_superuser ? "Yes" : "No"}</TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
